<script setup lang="ts">

const props = defineProps<{
    title: string
}>()
</script>

<template>
    <svg width="233" height="63" viewBox="0 0 233 63" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M232.88 42.34L114.93 62.75L0 42.34V0H232.88V42.34Z" fill="#F05A28" />
        <path d="M232.88 42.34L114.93 62.75L0 42.34V0L7.42999 35.66L114.42 56.96L232.88 42.34Z" fill="#D64B25" />
        <text x="50%" y="45%" text-anchor="middle" dominant-baseline="middle"
            class="font-bold text-2xl first-letter:capitalize">
            {{ props.title.charAt(0).toUpperCase() + props.title.slice(1) }}
        </text>
    </svg>
</template>